import React, { useState } from "react";
import Header from "../Header/Header";
import Navbar from "../Header/Navbar";
import AccountSidebar from "./AccountSidebar";
import { Link } from "react-router-dom";
const ProfitHistory = () => {
  const [activeButton, setActiveButton] = useState(" Current Bets");

  function handleButtonClick(button) {
    setActiveButton(button);
  }

  const navItems = [
    { name: "Current Bets", path: "/current-bets" },
    { name: "Bet History", path: "/bet-history" },
    { name: "Profit & Loss", path: "/profit-loss" },
  ];

  const navSubItems = [
    { name: "Exchange", path: "/exchange" },
    { name: "Fancy Bet", path: "/profit-loss" },
    { name: "Fancy1 Bet", path: "/profit-loss" },
    { name: "Sportbook", path: "/profit-loss" },
    { name: "Casino Bet", path: "/profit-loss" },
    { name: "Toss Bet", path: "/profit-loss" },
    { name: "Book Maker", path: "/profit-loss" },
    { name: "Premium", path: "/profit-loss" },
  ];

  return (
    <div>
      <Header />
      <Navbar />
      <div className="account_main  bg-[#f0ece1]   mt-1 flex">
        <AccountSidebar />
        <div className="balance_overview w-[70%]  mt-2   ml-4 ">
          <h2 className="font-bold mb-2">My Bets</h2>

          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`inplay_button ${
                activeButton === item.path.slice(1) ? "active" : ""
              }`}
              onClick={() => handleButtonClick(item.path.slice(1))}
              style={{
                backgroundColor:
                  activeButton === item.path.slice(1) ? "#3b5160" : "",
                color: activeButton === item.path.slice(1) ? "white" : "",
              }}
            >
              {item.name}
            </Link>
          ))}

          <div className="bg-[#fff] mt-3 py-1 px-2">
            <h2 className="font-extrabold  text-[#3b5160] text-[18px]">
              Profit & Loss - Main wallet
            </h2>
            <div className="flex items-center mt-1">
              <span className="text-sm mr-3"> demo12</span>
              <span>2023-05-30 23:30</span>
            </div>
            <div className="mt-3 border-top  border-5 border-[#3b5160]">
              {navSubItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`inplay_button ${
                    activeButton === item.path.slice(1) ? "active" : ""
                  }`}
                  onClick={() => handleButtonClick(item.path.slice(1))}
                  style={{
                    backgroundColor:
                      activeButton === item.path.slice(1) ? "#3b5160" : "",
                    color: activeButton === item.path.slice(1) ? "white" : "",
                  }}
                >
                  {item.name}
                </Link>
              ))}
            </div>
            <div
              className="bg-[#dcf0ff]   mt-3 px-2 py-4
          "
            >
              <div className="flex mb-2">
                <p className="">Bet Status:</p>
                <select
                  name=""
                  id=""
                  className="mx-2 px-2 border-gray-400 border-1 "
                >
                  <option value="">settled</option>
                </select>
                <p className="text-[12px]">Period</p>
                <input
                  type="date"
                  className="mx-2 px-2 border-gray-400 border-1 "
                  id="birthday"
                  name="birthday"
                ></input>
                <input type="text" className="w-[60px]" placeholder="9:00" />
                <p className="">To</p>
                <input
                  type="date"
                  className="mx-2 px-2 border-gray-400 border-1 "
                ></input>
                <input type="text" className="w-[60px]" placeholder="9:00" />
              </div>
              <button
                className="text-[12px]  border-gray-400 border-1  rounded px-3 py-1 mt-2 font-medium
              bg-[#fff]
          "
              >
                Just For Today
              </button>
              <button
                className="text-[12px]  border-gray-400 border-1  py-1 mx-3 rounded px-3 mt-2 font-medium
              bg-[#fff]
          "
              >
                Just For Today
              </button>
              <button
                className="text-[12px]  border-gray-400 border-1  py-1 mx-3 rounded px-3 mt-2 font-bold
              bg-[#fff429]
          "
              >
                Get P&L
              </button>
            </div>
            <div className="p mt-3">
              <h2 className="text-[16px mb-1]">
                Betting History enables you to review the bets you have placed.
              </h2>
              <h2 className="text-[16px mb-1]">
                Specify the time period during which your bets were placed, the
                type of markets on which the bets were placed, and the sport.
              </h2>
              <h2 className="text-[16px mb-1]">
                Specify the time period during which your bets were placed, the
                type of markets on which the bets were placed, and the sport.
              </h2>
            </div>
          </div>

          <div className="flex justify-between px-3 py-3">
            <div>
              <h2 className="font-bold">Total P/L: PBU (0.00)</h2>
            </div>
            <div>
              <select
                name=""
                id=""
                className="w-[100px] border-1 border-[#000] mr-2"
              >
                <option value="">Teniss</option>
                <option value="">All</option>
                <option value="">Soccer</option>
                <option value="">Cricket</option>
              </select>
              <span className="font-bold">PBU (0.00)</span>
            </div>
          </div>

          <div className="flex flex-col">
            <div className="overflow-x-auto">
              <div className="p-1.5 w-full inline-block align-middle">
                <div className="overflow-hidden border rounded-lg">
                  <table className="min-w-full divide-y bg-white divide-gray-200">
                    <thead className="bg-gray-300 text-[#000]">
                      <tr>
                        <th
                          scope="col"
                          colspan="3"
                          className="px-6 py-3 text-xs font-bold text-left  uppercase "
                        >
                          Market
                        </th>

                        <th
                          scope="col"
                          className="px-6 py-3 text-xs font-bold text-right  uppercase "
                        >
                          Settled date
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-xs font-bold text-right  uppercase "
                        >
                          Profit/Loss
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                      <div className="p-2">
                        You have no bets in this time period.
                      </div>
                      {/* <tr>
                        <td className="px-6 py-4 text-sm font-medium text-gray-800 whitespace-nowrap">
                          1
                        </td>
                        <td className="px-6 py-4 text-sm text-gray-800 whitespace-nowrap">
                          Jone Doe
                        </td>
                        <td className="px-6 py-4 text-sm text-gray-800 whitespace-nowrap">
                          jonne62@gmail.com
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-right whitespace-nowrap">
                          <a
                            className="text-green-500 hover:text-green-700"
                            href="#"
                          >
                            Edit
                          </a>
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-right whitespace-nowrap">
                          <a
                            className="text-red-500 hover:text-red-700"
                            href="#"
                          >
                            Delete
                          </a>
                        </td>
                      </tr> */}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfitHistory;
